import { get } from './API';

export default async function fetchGuides() {
  return get('pickup-guides');
}
